import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface ValidadeTokenInput {
  accessToken: string;
}

export interface ValidadeTokenOutput {
  success?: boolean;
}

export async function validadeToken(input: ValidadeTokenInput): Promise<FetchResponse<ValidadeTokenOutput>> {
  return await portalCustomAPI.fetch<ValidadeTokenInput, ValidadeTokenOutput>('validateToken', input);
}
